import { LoadingKey } from './key'
import ContentLoader from './react-content-loader'

const GridLoading = ({ className }: { className?: string }) => {
  return (
    <ContentLoader
      uniqueKey={LoadingKey.grid}
      viewBox='0 0 600 800'
      foregroundColor='var(--background-1st)'
      backgroundColor='var(--background-2nd)'
      speed={1.5}
      interval={0.5}
      gradientRatio={1}
      className={className}
    >
      <rect x='0' y='0' rx='2' ry='2' width='199' height='398' />

      <rect x='200' y='0' rx='2' ry='2' width='199' height='199' />
      <rect x='200' y='200' rx='2' ry='2' width='199' height='199' />
      <rect x='400' y='0' rx='2' ry='2' width='199' height='199' />
      <rect x='400' y='200' rx='2' ry='2' width='199' height='199' />

      <rect x='0' y='400' rx='2' ry='2' width='199' height='199' />
      <rect x='0' y='600' rx='2' ry='2' width='199' height='199' />
      <rect x='200' y='400' rx='2' ry='2' width='199' height='199' />
      <rect x='200' y='600' rx='2' ry='2' width='199' height='199' />

      <rect x='400' y='400' rx='2' ry='2' width='199' height='398' />
    </ContentLoader>
  )
}

export default GridLoading
